import { Component } from '@angular/core';

@Component({
  selector: 'app-stock',
  standalone: true,
  imports: [], 
  templateUrl: './stock.component.html',
  styleUrl: './stock.component.scss'
})
export class StockComponent {

}
